import { faFolder } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { memo } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { isInvalidMoveTarget } from '../helpers';

const FolderIcon = memo(({ item, selected, onDoubleClick, onDragEnd, handleContextMenu, itemsCache }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'folder',
    item: { id: item?.id, type: 'folder' },
    end: (draggedItem, monitor) => {
      const dropResult = monitor?.getDropResult();
      if (draggedItem?.id && dropResult && 'folderId' in dropResult) {
        onDragEnd(draggedItem.id, dropResult.folderId);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor?.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: ['report', 'folder'],
    canDrop: (draggedItem) => (
      draggedItem?.id !== item?.id
      && !isInvalidMoveTarget(draggedItem.id, draggedItem.type, item?.id, itemsCache)
    ),
    drop: () => ({ folderId: item?.id }),
    collect: (monitor) => ({
      isOver: monitor?.isOver(),
    }),
  });

  return (
    <div
      ref={(node) => drag(drop(node))}
      className={classNames("d-flex align-items-center py-2 px-3 desktop-icon",`${selected && 'selected '}`, `${isOver && 'folder-drop-target'}`)}
      onDoubleClick={onDoubleClick}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleContextMenu(e, item);
      }}
      style={{
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <FontAwesomeIcon icon={faFolder} size="lg" color="#314a9f" />
      <span>{item?.name}</span>
    </div>
  );
});

export default FolderIcon;
